import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@/primitives/Button'
import FlexV2 from '@/primitives/FlexV2'
import { toggleDateFilterSync } from '@/slices/management/trial'
import { getTrialState } from '@/components/TrialModeView/utils'
import Strings from '@/components/TrialModeView/Strings'

const DateSyncButton = ({ onSync }) => {
  const dispatch = useDispatch()
  const strings = Strings()
  const { dateFiltersSynced } = useSelector(getTrialState)

  const handleToggleSync = () => {
    const wasSync = !dateFiltersSynced
    dispatch(toggleDateFilterSync({}))

    if (wasSync && onSync) {
      onSync()
    }
  }

  return (
    <FlexV2 alignCrossAxis='center'>
      <Button
        variant={dateFiltersSynced ? 'primary' : 'outline'}
        iconBefore='sync'
        onClick={handleToggleSync}
      >
        {dateFiltersSynced ? strings.synced : strings.syncFilters}
      </Button>
    </FlexV2>
  )
}

export default DateSyncButton
